import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Utility from "../../utility/utility";

export default function TotalStockComponent({ data, sizeColumn, priceColumn }) {
  const makeData = (data) => {
    if (!Array.isArray(data)) return;

    let totalStones = data.length;
    let size = 0;
    let price = 0;
    let avgPrice = 0;
    data.forEach((item) => {
      size += sizeColumn && item[sizeColumn] ? parseFloat(item[sizeColumn]) : 0;
      price +=
        priceColumn && item[priceColumn] ? parseFloat(item[priceColumn]) : 0;
    });

    avgPrice = price / totalStones;

    return [totalStones, size, price, avgPrice];
  };

  const [totalStones, size, price, avgPrice] = makeData(data);

  return (
    <TableContainer component={Paper} sx={{ m: "15px 15px 0 0" }}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="simple table">
        <TableHead>
          <TableRow
            sx={{
              "& .css-12q85cb-MuiTableCell-root": {
                fontWeight: 600,
                backgroundColor: 'grey',
                color: 'white',
              },
              fontWeight: 600,
              backgroundColor: 'black',
              color: 'white',
            }}
          >
            <TableCell align="center">Total Stones</TableCell>
            {sizeColumn && <TableCell align="center">Total Size</TableCell>}
            {priceColumn && <TableCell align="center">Total Price</TableCell>}
            {sizeColumn && priceColumn && (
              <TableCell align="center">Average Price</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
            <TableCell align="center">
              {totalStones ? totalStones : 0.00}
            </TableCell>
            {sizeColumn && (
              <TableCell align="center">{Utility.ConvertNumberWithSpecifiedDigits(size)}</TableCell>
            )}
            {priceColumn && (
              <TableCell align="center">
                {Utility.ConvertNumberWithSpecifiedDigits(price)}
              </TableCell>
            )}
            {sizeColumn && priceColumn && (
              <TableCell align="center">
                {avgPrice ? Utility.ConvertNumberWithSpecifiedDigits(avgPrice) : 0.00}
              </TableCell>
            )}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
